/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SmoothLink, buildThumbnailUrl, menuToggler } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { BtnAnimationSheen } from '../../../helpers/UIElements';
import ContactModal from '../../../components/ContactModal';
import { colors } from '../../../styles';
import Carousel from '../../../components/Carousel';

const styles = css`
  position: relative;
  .HeroImage_wrapper {
    width: 100%;
    height: 65vh;
    min-height: 570px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media(min-width: 576px) {
      min-height: 387px;
    }
    @media(min-width: 768px) {
      height: 80vh;
      background-attachment: fixed;
    }
    @media(min-width: 992px) {
      height: calc(100vh - 30px);
    }
    @media(min-width: 4000px) {
      height: calc(70vh - 30px);
    }
  }
  .HeroImage_textbox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(180deg, rgba(30,30,30,0.70) 0%, rgba(30,30,30,0.20) 48%);
  }
  .HeroImage_h1 {
    font-weight: 300;
    font-size: 52px;
    color: #FFFFFF;
    letter-spacing: 1.31px;
    text-align: center;
    line-height: 51px;
    @media(min-width: 992px) {
      /* font-size: 81px; */
      font-size: 75px;
      line-height: 81px;
      /* letter-spacing: 2.22px; */
      letter-spacing: 1.5px;
    }
  }
  .HeroImage_btnsWrapper {
    margin: 30px 0 0;
    display: flex;
    flex-direction: column;
    @media(min-width: 992px) {
      flex-direction: row;
      margin: 40px 0 0;
    }
    li:last-child {
      margin: 15px 0 0;
      @media(min-width: 992px) {
        margin: 0 0 0 15px;
      }
    }
  }
  .HeroImage_btn {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(214, 155, 41, 0.65);
    min-width: 263px;
    transition: all .3s ease-out;
    @media(min-width: 992px) {
      min-width: 315px;
    }
    &:hover {
      @media(min-width: 768px) {
        background-color: rgba(214, 155, 41, 0.85);
        transform: scale(1.05);
      }
    }
    &::before {
      content: '';
      width: 116px;
      height: 3px;
      background-color: #7d5f26;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
    &::after {
      z-index: -1;
    }
  }
  .HeroImage_btnLink {
    font-weight: 700;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    cursor: pointer;
    @media(min-width: 992px) {
      height: 68px;
      font-size: 19px;
    }
  }
  .HeroImage_smoothLink {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 60px;
    display: none;
    width: 24px;
    height: 24px;
    border: 1px solid red;
    border-style: solid;
    border-color: white;
    border-width: 0px 1px 1px 0px;
    transform: rotate(45deg);
    transition: all .3s ease-in-out;
    @media(min-width: 992px) {
      display: flex;
    }
    &:hover {
      animation: bounce 1s infinite;
    }
  }
  @keyframes bounce {
    70% { bottom: 50px; }
  }
  .ContactModal_button{
    @media(min-width: 768px){
      cursor: pointer;
      position: absolute;
      bottom: 53px;
      right: 64px;
      height: 64px;
      width: 64px;
      background-color: ${colors.color1};
      background-image: url('/images/icons/icon-bubble.svg');
      background-size: 50%;
      background-position: center;
      background-repeat: no-repeat;
      z-index:1;
      border-radius: 100%;
    }
  }

  .HeroImage_dropdownWrapper {
    position: absolute;
    left: 0;
    top: 60px;
    background-color: rgba(0, 0, 0, 0.9);
    width: 100%;
    z-index: 1;
    @media(min-width: 992px) {
      background-color: rgba(0, 0, 0, 0.6);
    }
    li {
      & + li {
        border-top: 1px solid #393939;
      }
    }

    .HeroImage_dropdownLink {
      width: 100%;
      height: 60px;
      justify-content: center;
      align-items: center;
      color: #FFF;
      font-size: 16px;
      display: flex;
      transition: all .3s ease-out;
      &:hover {
        background-color: #000;
        color: ${colors.color1};
      }
    }
  }
`;

class HeroSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // slider: 0,
      // hover: false,
      slides: [],
    };
  }
  componentDidMount() {
    // this.interval = setInterval(this.next, 5000);
    this.getSlides();
  }

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // }

  // onMouseEnterHandler = () => {
  //   this.setState({
  //     hover: true,
  //   });
  // }
  //
  // onMouseLeaveHandler = () => {
  //   this.setState({
  //     hover: false,
  //   });
  // };
  getSlides = () => {
    const { content } = this.props;
    const slides = get(content, 'images');
    // slides.push({
    //   '@type': 'ImageContent',
    //   'contentUrl': 'https://s3.amazonaws.com/buildercloud/9e1e75b0e7c6808b57c2697a7145fd84.png',
    // },
    // {
    //   '@type': 'ImageContent',
    //   'contentUrl': 'https://s3.amazonaws.com/buildercloud/57af47253e36f9aec4bf19b71c9196b9.png',
    // });
    // console.log(slides);
    this.setState({ slides });
  }

  // next = () => {
  //   if (!this.state.hover) {
  //     const { slider, slides } = this.state;
  //     const nextIndex = (slider + 1 >= slides.length) ? 0 : slider + 1;
  //     this.setState({
  //       slider: nextIndex,
  //     });
  //   }
  // }

  // changeSlideHandler = index => {
  //   this.setState({
  //     slider: index,
  //   });
  // }

  render() {
    // const { content, activateMenu, isActiveMenu } = this.props;
    const { content } = this.props;
    // const { slider, slides } = this.state;
    const { slides } = this.state;
    return (
      <Carousel
        autoplay
        interval={4500}
        indicators
        items={slides.map(slide => ({
          element: (
            <div
              className={styles}
              // onMouseEnter={this.onMouseEnterHandler}
              // onMouseLeave={this.onMouseLeaveHandler}
            >
              <ContactModal>
                <div className="ContactModal_button" />
              </ContactModal>
              <div
                className="HeroImage_wrapper"
                style={{ backgroundImage: `url(${buildThumbnailUrl(get(slide, 'contentUrl'), { width: 2000, height: 2000, preserve: true })})` }}
              />
              <div className="HeroImage_textbox">
                <h1 className="HeroImage_h1">{get(content, 'title')}</h1>
                <ul className="d-md-flex list-unstyled HeroImage_btnsWrapper">
                  <li className="position-relative">
                    <BtnAnimationSheen className="HeroImage_btn">
                      { /* <span className="HeroImage_btnLink"
                        role="button" tabIndex={0} onClick={activateMenu('homesMenu')}>
                        Available Homes
                      </span> */ }
                      <Link className="HeroImage_btnLink" name="homes">Available Homes</Link>
                    </BtnAnimationSheen>
                    { /*
                      isActiveMenu('homesMenu') &&
                      <ul className="list-unstyled HeroImage_dropdownWrapper">
                        <li>
                          <Link
                            name="homes"
                            params={{
                              communityMarketAreaMetro: 'Bellevue',
                              communityMarketArea: 'Bellevue',
                            }}
                            className="HeroImage_dropdownLink"
                          >
                            Bellevue Homes
                          </Link>
                        </li>
                        <li>
                          <Link
                            name="homes"
                            params={{
                              communityMarketAreaMetro: 'Mercer Island',
                              communityMarketArea: 'Mercer Island',
                            }}
                            className="HeroImage_dropdownLink"
                          >
                            Mercer Island Homes
                          </Link>
                        </li>
                        <li><Link name="tour-model-homes"
                        className="HeroImage_dropdownLink">Tour Model Homes</Link></li>
                      </ul>
                  */ }
                  </li>
                  <li>
                    <BtnAnimationSheen className="HeroImage_btn">
                      <Link name="communities" className="HeroImage_btnLink">
                        Communities
                      </Link>
                    </BtnAnimationSheen>
                  </li>
                </ul>
                <SmoothLink className="HeroImage_smoothLink" href="#welcome" />
              </div>
            </div>
          )
        }))}
      />
    );
  }
}

HeroSlider.propTypes = {
  content: PropTypes.object.isRequired,
  // activateMenu: PropTypes.func.isRequired,
  // isActiveMenu: PropTypes.func.isRequired,
};

export default menuToggler(HeroSlider);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroSlider/HeroSliderComponent.js